import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10801abd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-team-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom" }
const _hoisted_3 = { class: "season-team-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "エントリーチームを追加", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "entry-team-list"
}
const _hoisted_8 = { class: "category" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "global-empty-text"
}
const _hoisted_15 = {
  key: 2,
  class: "entry-add-card"
}
const _hoisted_16 = { class: "container" }
const _hoisted_17 = {
  key: 0,
  class: "entry-add-panel"
}
const _hoisted_18 = { class: "global-search-input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-search icon" }, null, -1))
const _hoisted_20 = { class: "team-list" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "category" }
const _hoisted_23 = { class: "name" }
const _hoisted_24 = {
  key: 0,
  class: "number"
}
const _hoisted_25 = {
  key: 1,
  class: "global-empty-text -small"
}
const _hoisted_26 = { class: "footer" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "新規チームを追加", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "team-add-panel"
}
const _hoisted_31 = { class: "global-select" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: ""
}, "カテゴリを選ぶ", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "チームを追加", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "footer" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-left icon" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "チーム選択へ戻る", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "global-add-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openEntryAddCard && _ctx.openEntryAddCard(...args)))
          }, _hoisted_6),
          (_ctx.entries.list && _ctx.entries.list.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list, (team) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: team.id,
                    class: "item"
                  }, [
                    _createVNode(_component_router_link, {
                      to: { name: 'seasonEntryDetail', params: { team_id: team.id } },
                      class: "entry-team-list-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_8, [
                          _createElementVNode("span", {
                            class: "categoryIcon",
                            style: _normalizeStyle({ 'background-color': team.category_color })
                          }, null, 4)
                        ]),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(team.team_name), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "entry-team-division-input",
                          placeholder: "分割名を入力",
                          "onUpdate:modelValue": ($event: any) => ((team.division) = $event),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                          onChange: ($event: any) => (_ctx.updateEntryDivision($event, team))
                        }, null, 40, _hoisted_10), [
                          [_vModelText, team.division]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "global-delete-button",
                          onClick: _withModifiers(($event: any) => (_ctx.openEntryDialogDelete(team)), ["prevent"])
                        }, _hoisted_13, 8, _hoisted_11)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : (!_ctx.teams.isLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "登録されているエントリーチームがありません"))
              : _createCommentVNode("", true),
          (_ctx.entryAddCard.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "entry-add-card-overlay",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeEntryAddCard && _ctx.closeEntryAddCard(...args)))
                }),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.entryAddCard.panel === 'entryAdd')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input",
                            placeholder: "チームを検索",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entryAddCard.searchForm.keyword) = $event)),
                            onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getTeams && _ctx.getTeams(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.entryAddCard.searchForm.keyword]
                          ])
                        ]),
                        (_ctx.teams.list.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("ul", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams.list, (team) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: team.id,
                                    class: "item"
                                  }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "team-list-card",
                                      onClick: ($event: any) => (_ctx.addEntry(team.id))
                                    }, [
                                      _createElementVNode("p", _hoisted_22, [
                                        _createElementVNode("span", {
                                          class: "categoryIcon",
                                          style: _normalizeStyle({ 'background-color': team.category_color })
                                        }, null, 4)
                                      ]),
                                      _createElementVNode("p", _hoisted_23, _toDisplayString(team.name), 1)
                                    ], 8, _hoisted_21)
                                  ]))
                                }), 128))
                              ]),
                              (_ctx.entryAddCard.searchForm.others > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_24, "他" + _toDisplayString(_ctx.entryAddCard.searchForm.others) + "件", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("p", _hoisted_25, "該当のチームがありません")),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            class: "global-add-button -only-text -round",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeEntryAddCardPanel('teamAdd')))
                          }, _hoisted_29)
                        ])
                      ]))
                    : (_ctx.entryAddCard.panel === 'teamAdd')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("select", {
                              class: "select -small",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.teamForm.category_id) = $event))
                            }, [
                              _hoisted_32,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamCategories.list, (category) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: category.id,
                                  value: category.id
                                }, _toDisplayString(category.name), 9, _hoisted_33))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.teamForm.category_id]
                            ])
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "global-input",
                            placeholder: "チーム名を入力",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.teamForm.name) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.teamForm.name]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "global-input",
                            placeholder: "省略チーム名を入力",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.teamForm.short_name) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.teamForm.short_name]
                          ]),
                          _createElementVNode("button", {
                            class: "global-button",
                            disabled: !_ctx.teamForm.isCompleted,
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addTeamAndEntry && _ctx.addTeamAndEntry(...args)))
                          }, _hoisted_37, 8, _hoisted_34),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                              class: "global-button -only-text -round",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeEntryAddCardPanel('entryAdd')))
                            }, _hoisted_41)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.entryDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.entryDialogDelete,
          onCloseDialog: _ctx.closeEntryDialogDelete,
          onOnConfirm: _ctx.deleteEntry
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}